import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

import { BlankButton } from 'modules/UI/components/BlankButton';
import { MAX_CONTENT_WIDTH } from 'modules/UI/constants';

import { NOTIFICATION_VARIANTS } from '../../types';

type ContainerProps = {
  variant: NOTIFICATION_VARIANTS;
};

export const Markup = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-gap: ${tokens.lineHeights.xs};
`;

export const Content = styled.div`
  padding: ${tokens.space.small} ${tokens.space.regular};
  width: 100%;
  max-width: ${MAX_CONTENT_WIDTH};
  text-align: center;
  margin: auto;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 32px;
  box-sizing: border-box;
`;

export const CloseButton = styled(BlankButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${tokens.colors.white};
`;

export const Container = styled.div<ContainerProps>`
  width: 100%;

  ${({ variant }): string | false =>
    variant === NOTIFICATION_VARIANTS.ATTENTION && `background-color: ${tokens.colors.attention};`}
  ${({ variant }): string | false =>
    variant === NOTIFICATION_VARIANTS.INFORMATIVE && `background-color: ${tokens.colors.informative};`}
  ${({ variant }): string | false =>
    variant === NOTIFICATION_VARIANTS.SUCCESS && `background-color: ${tokens.colors.positive};`}
  ${({ variant }): string | false =>
    variant === NOTIFICATION_VARIANTS.ERROR && `background-color: ${tokens.colors.error};`}
`;
